import { render, staticRenderFns } from "./ClientUpdateAvailable.vue?vue&type=template&id=28f03763"
import script from "./ClientUpdateAvailable.vue?vue&type=script&lang=js"
export * from "./ClientUpdateAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports